import { useContext } from 'react';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { responsiveSizeTimesheet, timesheetsStatuses } from '../../../../../utils/constants';
import { tneAxiosClient } from '../../../../../api/apiSettings';

import { EditExpenseContext } from '../../../../../context/editContexts';
import { basicErrorHandler } from '../../../../../utils/helpers';
import { generalEnums } from '../../../../../utils/enums';

export const ExpenseHeaderConfig = (t, data, size, classes, isApprover, getFormData) => {
  const ctx = useContext(EditExpenseContext);
  const dispatch = useDispatch();
  const handleClaimDescriptionSave = async (e) => {
    try {
      const formData = getFormData(data);
      formData.append('ClaimDescription', e.currentTarget.textContent);
      await tneAxiosClient.put(`v1/expense?expenseId=${data.Id}`, formData);
    } catch (error) {
      basicErrorHandler(dispatch, error.message);
    }
  };

  const isDescriptionEditable = () =>
    data?.Status?.Status !== timesheetsStatuses(t).approved.apiStatus &&
    data?.Status?.Status !== timesheetsStatuses(t).processed.apiStatus;

  const handleKeyUp = (e) => {
    const { length } = e.target.innerText.trim();

    if (length >= 50 && e.keyCode !== 8) {
      e.preventDefault();
      return false;
    }

    return true;
  };

  const renderHeaderLeft = () => {
    if (size.width > responsiveSizeTimesheet) {
      return (
        <div
          role="presentation"
          onKeyDown={(e) => handleKeyUp(e)}
          onBlur={(e) => handleClaimDescriptionSave(e)}
          contentEditable={ctx?.isEdit && !isApprover && isDescriptionEditable()}
          className={`${classes.monthLabel} ${ctx?.isEdit && classes.hoverDescription}`}
        >
          {data?.ClaimDescription.substr(0, 50)}
        </div>
      );
    }

    return (
      <div className={classes.mobileClientPlacement}>
        <span className={classes.clientName}>
          {isApprover ? `${data?.User?.FirstName} ${data?.User?.LastName}` : data?.ClientName}
        </span>
        ,&nbsp;
        <span className={classes.placement}>{data?.JobTitle}</span>
      </div>
    );
  };

  return {
    headerLeft: renderHeaderLeft(),
    keyValueLabels: [
      {
        label: isApprover ? t('dashboard.timesheet.header.contractor') : t('dashboard.timesheet.header.client'),
        value: isApprover ? `${data?.User?.FirstName} ${data?.User?.LastName}` : data?.ClientName
      },
      {
        label: t('dashboard.timesheet.header.jobtitle'),
        value: data?.JobTitle
      },
      {
        label: t('dashboard.timesheet.header.date'),
        value: dayjs(data?.CreatedDate).format(generalEnums.DATEWITH_MMM)
      },
      {
        label: t('dashboard.timesheet.header.recordn'),
        value: data?.RecordNo
      },
      {
        label: t('dashboard.timesheet.header.order'),
        value: data?.PoNumber || '-'
      }
    ]
  };
};
